import React from 'react';
import { TitleWithPreview } from '@laigu/component';
import { Switch } from 'antd';

import TitleInfo, { PropsType as TitleInfoPropType } from './components/title-info';
import BlockEdit, { PropsType as BlockEditPropType } from './components/block-edit';

import style from './index.less';

export interface ActionType {
  (a: boolean): JSX.Element;
}

interface PropsType extends BlockEditPropType {
  title?: JSX.Element | string;
  className?: string;
  info?: JSX.Element | string;
  onEdit?: () => void;
  action?: ActionType;
  type?: 'large' | 'medium' | 'small';
  preview?: string;
  wideImg?: boolean;
  switchProps?: any;
  editorEl?: JSX.Element;
  needVline?: boolean;
  slotContent?: JSX.Element;
}

interface IBlockTitle extends React.FC<PropsType> {
  TitleInfo: React.FC<TitleInfoPropType>;
  BlockEdit: React.FC<BlockEditPropType>;
}

const BlockTitle: IBlockTitle = (props: PropsType) => {
  const {
    title,
    className,
    info,
    onEdit,
    action,
    preview,
    type,
    wideImg,
    switchProps,
    editorEl,
    needVline = false,
    slotContent
  } = props;

  return (
    <>
      <div className={`${style.title} ${className} block-title`}>
        <div className={style.left}>
          {needVline ? <span className={style.rect} /> : null}
          {title ? (
            preview ? (
              <TitleWithPreview type={type} src={preview} wideImg={wideImg}>
                {title}
              </TitleWithPreview>
            ) : (
              <>
                <h1 className={needVline ? style.vLineTitle : ''}>{title}</h1>
                {slotContent ?? slotContent}
              </>
            )
          ) : null}
        </div>
        {onEdit || action ? <BlockEdit {...props} /> : null}
        {editorEl ?? editorEl}
        {switchProps ? (
          <div className={style.disf}>
            <span>{switchProps.checked ? '已启用' : '未启用'}</span> <Switch {...switchProps} />
          </div>
        ) : null}
      </div>
      {info ? <TitleInfo text={info} /> : null}
    </>
  );
};

BlockTitle.TitleInfo = TitleInfo;
BlockTitle.BlockEdit = BlockEdit;

export default BlockTitle;
